export const APPEARANCE_STORAGE_KEY = 'shinai:appearance:v1'

export const DEFAULT_APPEARANCE = Object.freeze({
    visibleScrollbar: false,
    heroTrailersEnabled: false,
})

let runtimeAppearance = null
const appearanceListeners = new Set()

function browserStorage() {
    if (typeof window === 'undefined') return null
    try {
        return window.localStorage
    } catch (_) {
        return null
    }
}

function documentRoot() {
    if (typeof document === 'undefined') return null
    return document.documentElement
}

function normalizeAppearance(value) {
    return {
        visibleScrollbar: value?.visibleScrollbar === true,
        heroTrailersEnabled: value?.heroTrailersEnabled === true,
    }
}

function rememberAppearance(value) {
    runtimeAppearance = normalizeAppearance(value)
    return { ...runtimeAppearance }
}

function fallbackAppearance() {
    return runtimeAppearance
        ? { ...runtimeAppearance }
        : { ...DEFAULT_APPEARANCE }
}

export function readAppearance(storage = browserStorage()) {
    if (!storage) return fallbackAppearance()

    try {
        const storedValue = storage.getItem(APPEARANCE_STORAGE_KEY)
        if (!storedValue) return fallbackAppearance()
        return rememberAppearance(JSON.parse(storedValue))
    } catch (_) {
        return fallbackAppearance()
    }
}

export function applyAppearance(appearance, root = documentRoot()) {
    const normalized = rememberAppearance(appearance)
    root?.classList?.toggle('scrollbars-visible', normalized.visibleScrollbar)
    return normalized
}

export function writeAppearance(appearance, storage = browserStorage(), root = documentRoot()) {
    const normalized = applyAppearance({
        ...readAppearance(storage),
        ...appearance,
    }, root)
    try {
        storage?.setItem(APPEARANCE_STORAGE_KEY, JSON.stringify(normalized))
    } catch (_) {
        // The module-level state keeps the preference for this session.
    }
    appearanceListeners.forEach((listener) => {
        try {
            listener({ ...normalized })
        } catch (_) {
            // One listener must not prevent the preference from reaching the others.
        }
    })
    return normalized
}

export function initializeAppearance(storage = browserStorage(), root = documentRoot()) {
    return applyAppearance(readAppearance(storage), root)
}

export function subscribeAppearance(listener) {
    if (typeof listener !== 'function') return () => {}
    appearanceListeners.add(listener)
    return () => appearanceListeners.delete(listener)
}
